import * as React from 'react';

interface Props {
  style?: React.CSSProperties;
  align?: 'flex-start' | 'flex-end' | 'center';
}

const defaultProps: Props = {
  align: 'flex-end',
};

class ButtonBar extends React.Component<Props, {}> {

  private containerStyle: React.CSSProperties = {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: this.props.align ?? 'flex-end',
    margin: '-4px -4px'
  };

  private itemStyle: React.CSSProperties = {
    margin: '4px 4px'
  };

  constructor(props: Props = defaultProps) {
    super(props);
  }

  public render(): React.ReactNode {
    const {children, style} = this.props;
    return (
      <div style={style}>
        <div style={this.containerStyle}>
          {children && React.Children.map(children, child => (
            child && (
              <div style={this.itemStyle}>
                {child}
              </div>
            )
          ))}
        </div>
      </div>
    );
  }
}

export default ButtonBar;


// WEBPACK FOOTER //
// ./src/common/ButtonBar.tsx